(() => {
  if (window.FGDiscountCopyInitialized) return;

  window.FGDiscountCopyInitialized = true;

  const fallbackCopy = (code) => {
    const input = document.createElement('textarea');
    input.value = code;
    input.setAttribute('readonly', '');
    input.style.position = 'fixed';
    input.style.inset = '0 auto auto 0';
    input.style.opacity = '0';
    document.body.append(input);
    input.select();
    input.setSelectionRange(0, code.length);
    const copied = document.execCommand('copy');
    input.remove();
    return copied;
  };

  const copyCode = async (code) => {
    let modernCopied = false;

    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(code);
        modernCopied = true;
      } catch (error) {
        modernCopied = false;
      }
    }

    let legacyCopied = false;

    try {
      legacyCopied = fallbackCopy(code);
    } catch (error) {
      legacyCopied = false;
    }

    return modernCopied || legacyCopied;
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-discount-copy]');
    if (!button) return;

    const code = (button.dataset.discountCopy || '').trim().toUpperCase();
    if (!code) return;

    button.disabled = true;

    try {
      const copied = await copyCode(code);
      if (!copied) return;

      button.classList.add('is-copied');
      button.setAttribute('aria-label', button.dataset.copiedLabel || code);

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'discount_code_copied', discount_code: code });
      document.dispatchEvent(new CustomEvent('fg:discount-copied', { detail: { code } }));

      window.setTimeout(() => {
        button.classList.remove('is-copied');
        button.setAttribute('aria-label', button.dataset.copyLabel || code);
      }, 2400);
    } finally {
      button.disabled = false;
    }
  });
})();
